import React from 'react';
import { EightDReport, UpdateFieldFn } from '../../types/eightd.types';
import { FracasIncident } from '../../types/fracas.types';

interface EightDBasicInfoProps {
    report: Partial<EightDReport>;
    updateField: UpdateFieldFn;
    incidents: FracasIncident[];
}

export const EightDBasicInfo: React.FC<EightDBasicInfoProps> = ({
    report,
    updateField,
    incidents,
}) => {
    return (
        <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Basic Information</h2>
            <div className="grid md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Report Title *
                    </label>
                    <input
                        type="text"
                        value={report.title || ''}
                        onChange={(e) => updateField('title', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Brief description of the problem"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Product Name *
                    </label>
                    <input
                        type="text"
                        value={report.productName || ''}
                        onChange={(e) => updateField('productName', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Product affected"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Customer Name *
                    </label>
                    <input
                        type="text"
                        value={report.customerName || ''}
                        onChange={(e) => updateField('customerName', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        placeholder="Customer or internal department"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Link to FRACAS Incident (Optional)
                    </label>
                    <select
                        value={report.fracasIncidentId || ''}
                        onChange={(e) => {
                            const incident = incidents.find(i => i.id === e.target.value);
                            updateField('fracasIncidentId', e.target.value);
                            updateField('fracasNumber', incident?.fracasNumber);
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                        <option value="">-- None --</option>
                        {incidents.map(incident => (
                            <option key={incident.id} value={incident.id}>
                                {incident.fracasNumber} - {incident.title}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
};
